"use client"

import { useEffect } from "react"

export function Mouseflow() {
  useEffect(() => {
    // Initialize the Mouseflow queue
    window._mfq = window._mfq || []

    // Create and append the Mouseflow script
    const mf = document.createElement("script")
    mf.type = "text/javascript"
    mf.defer = true
    mf.src = "//cdn.mouseflow.com/projects/47ac5f31-5689-4899-a2f2-def8605a0040.js"

    // Append to head
    document.head.appendChild(mf)

    // Cleanup function to remove script if component unmounts
    return () => {
      const existingScript = document.querySelector('script[src*="mouseflow.com"]')
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [])

  // This component doesn't render anything visible
  return null
}
